import { BusquedaBanner } from '../component/Busquedas/BusquedaBanner';
import { Hiring } from '../component/Busquedas/Hiring';
import Header from '../component/Header';

export const Busquedas = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <Header />
      <BusquedaBanner />
      <Hiring />
    </div>
  );
}
